// globalMethods.ts
export function capitalize(value: string) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function abbreviateNumber(value: number | string): string {
  // Convert value to a number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return '';

  // Round the number to avoid floating-point precision issues
  const roundedValue = Number(numValue.toFixed(1));

  // If the value is less than 1000, return as it is
  if (roundedValue < 1000) {
    return roundedValue.toString();
  }
  
  // Convert to "k" format for thousands
  return (roundedValue / 1000).toFixed(1) + 'k';
}
